import { get as dbGet, set as dbSet } from "../services/db";
export const get = async (uid) => {
  return await dbGet("users/" + uid);
};
export const update = async (uid, data) => {
  await dbSet("users/" + uid, data);
};
